/**
 * Detect if WebGL is available in the browser
 * @returns true if WebGL is supported and enabled
 */
export const isWebGLAvailable = (): boolean => {
  try {
    const canvas = document.createElement('canvas');
    const context =
      canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    return !!context;
  } catch (e) {
    return false;
  }
};

/**
 * Get WebGL context information for debugging
 */
export const getWebGLInfo = (): {
  available: boolean;
  renderer?: string;
  vendor?: string;
} => {
  if (!isWebGLAvailable()) {
    return { available: false };
  }

  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

    if (!gl) {
      return { available: false };
    }

    const debugInfo = (gl as WebGLRenderingContext).getExtension('WEBGL_debug_renderer_info');
    const renderer = debugInfo
      ? (gl as WebGLRenderingContext).getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
      : 'Unknown';
    const vendor = debugInfo
      ? (gl as WebGLRenderingContext).getParameter(debugInfo.UNMASKED_VENDOR_WEBGL)
      : 'Unknown';

    return {
      available: true,
      renderer,
      vendor,
    };
  } catch (e) {
    return { available: false };
  }
};
